import { gql } from '@apollo/client';
import { Role } from 'auth';
import { GqlProgram } from '../fragments/program';

export interface Variables {
  seasonId: string;
}

export interface Data {
  showStaff: Array<GqlStaff>;
}

export interface UserRole {
  type: Role;
  userId: string;
  personId: string;
  scopeId: string;
  scopeType: string;
}

export interface StaffRole {
  type: Role;
  organizationId: string;
  program: any;
  programs: {id: number, name: string}[];
  season: {id: number, name: string};
  divisions: {id: number, name: string}[];
}

// TODO: Export me to another file?
export interface GqlStaff {
  id: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
  phoneNumber: string;
  roles: Array<UserRole>;
  staffRoles: Array<StaffRole>
  organizationId: number;
  invitationStatus: string;
  personId: number;
  userId: string;
}

export const QUERY = gql`
  query ShowStaff($organizationId: Int!) {
    showOrganization(organizationId: $organizationId) {
      id
      staff {
        id
        firstName
        lastName
        emailAddress
        phoneNumber
        roles {
          type
          personId
          userId
          scopeId
          scopeType
        }
        staffRoles {
          type
          programs {
            id
            name
          }
          season {
            id
            name
          }
          divisions {
            id
            name
          }
        }
        organizationId
        invitationStatus
        personId
        userId
      }
    }
  }
`;
